import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "student-table-new"
};
const _hoisted_2 = {
  class: "scroll-area"
};
const _hoisted_3 = {
  class: "header-row"
};
const _hoisted_4 = {
  class: "period-label"
};
const _hoisted_5 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.weeks, (week, weekIndex) => {
    return _openBlock(), _createElementBlock("div", {
      key: weekIndex,
      class: "week"
    }, [_createElementVNode("div", _hoisted_3, [_cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "period-head"
    }, null, -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week, day => {
      return _openBlock(), _createElementBlock("div", {
        key: day.completeDate,
        class: _normalizeClass(['day-head', {
          today: day.completeDate === $props.todayDate,
          grey: day.ifGrey
        }])
      }, [_createElementVNode("b", null, _toDisplayString(day.date), 1), _createElementVNode("span", null, _toDisplayString(day.dayOfWeekText), 1)], 2);
    }), 128))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.periods, period => {
      return _openBlock(), _createElementBlock("div", {
        key: period,
        class: "period-row"
      }, [_createElementVNode("div", _hoisted_4, _toDisplayString(period), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week, day => {
        return _openBlock(), _createElementBlock("div", {
          key: day.completeDate + period,
          class: "cell"
        }, [$options.courseAt(day.completeDate, period) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "course",
          style: _normalizeStyle({
            background: $options.lightColorFor($options.courseAt(day.completeDate, period).course)
          })
        }, [_createElementVNode("i", {
          style: _normalizeStyle({
            background: $options.colorFor($options.courseAt(day.completeDate, period).course)
          })
        }, null, 4), _createElementVNode("strong", null, _toDisplayString($options.courseAt(day.completeDate, period).className), 1), _createElementVNode("span", null, _toDisplayString($options.courseAt(day.completeDate, period).teacherName) + " · " + _toDisplayString($options.courseAt(day.completeDate, period).course), 1), _createElementVNode("em", {
          style: _normalizeStyle({
            background: $options.colorFor($options.courseAt(day.completeDate, period).course)
          })
        }, _toDisplayString($options.courseAt(day.completeDate, period).courseType), 5)], 4)) : $options.scheduleAt(day.completeDate, period) ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "schedule",
          onClick: $event => _ctx.$emit('edit-schedule', $options.scheduleAt(day.completeDate, period))
        }, [_createElementVNode("strong", null, _toDisplayString($options.scheduleAt(day.completeDate, period).title), 1), _createElementVNode("span", null, _toDisplayString($options.scheduleAt(day.completeDate, period).scheduleContent || "个人日程"), 1), _cache[1] || (_cache[1] = _createElementVNode("em", null, "日程", -1))], 8, _hoisted_5)) : _createCommentVNode("", true)]);
      }), 128))]);
    }), 128))]);
  }), 128))])]);
}